import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqItems = [
  {
    q: "Kapan waktu terbaik untuk memesan aqiqah?",
    a: "Idealnya 3–7 hari sebelum acara. Namun kami juga menerima pesanan mendadak (H-1) jika slot tersedia.",
  },
  {
    q: "Apakah bisa request menu masakan?",
    a: "Bisa! Selain gule & sate, kami juga bisa menyiapkan tongseng, rendang, kari atau pesanan khusus anda.",
  },
  {
    q: "Apakah melayani luar Depok?",
    a: "Ya, kami melayani seluruh Jabodetabek dan juga penyaluran aqiqah ke luar kota dengan dokumentasi lengkap.",
  },
  {
    q: "Apakah ada sertifikat aqiqah?",
    a: "Setiap paket disertai sertifikat aqiqah eksklusif dengan desain elegan, termasuk versi digital dan cetak.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* 🟠 Floating FAQ Button (Presisi 64x64 & jarak antar badge seimbang) */}
      <motion.button
        onClick={() => setOpen(true)}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        // ✅ Presisi: berjarak 15px dari badge Kalender (bottom-[182px])
        className="fixed bottom-[182px] right-6 z-[70] bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white w-16 h-16 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center font-bold text-lg tracking-wide"
        aria-label="FAQ Toyibah Aqiqah"
      >
        FAQ
      </motion.button>

      {/* 🟣 Soft Popup FAQ */}
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[80] flex items-center justify-center bg-black/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0, y: 40 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.85, opacity: 0, y: 40 }}
              transition={{ duration: 0.35, ease: "easeOut" }}
              className="relative bg-gradient-to-b from-[#FFF8F6] via-[#FFF5F2] to-white rounded-3xl shadow-2xl p-6 sm:p-8 w-[90%] max-w-md mx-auto text-center border border-[#FFD8C8]/50"
            >
              {/* ❌ Close Button */}
              <button
                onClick={() => setOpen(false)}
                className="absolute top-3 right-3 text-[#FF8A65] hover:text-[#FF6B4A] transition"
              >
                <X className="w-5 h-5" />
              </button>

              {/* Header */}
              <div className="flex flex-col items-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white shadow-md mb-3 font-bold">
                  FAQ
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-[#333] mb-1">
                  Pertanyaan Umum
                </h3>
                <p className="text-sm text-[#777]">
                  Seputar layanan{" "}
                  <span className="text-[#FF8A65] font-semibold">
                    Toyibah Aqiqah
                  </span>
                </p>
              </div>

              {/* Accordion FAQ */}
              <Accordion type="single" collapsible className="space-y-3">
                {faqItems.map((item, i) => (
                  <AccordionItem
                    key={i}
                    value={`faq-${i}`}
                    className="bg-white border border-[#FFD8C8]/60 rounded-xl px-4 py-2 shadow-sm hover:shadow-md transition-all duration-300"
                  >
                    <AccordionTrigger className="text-left text-[#333] font-semibold text-sm hover:text-[#FF8A65]">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#777] text-sm leading-relaxed">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FAQ;
